define(
    'modules/menu',[
        'jquery',

        'settings',

        'utils/body-scroll',
        'utils/bind-lifo-stack',
        'utils/fit-screen-vertically',

        'libs/respond/respond'
    ],
    function ($, settings, bodyScroll, bindStack, FitScreenVertically, respond) {

        /**
         * @class Menu
         * @description Responsible for mobile and desktop events.
         */
        var Menu = function() {
            var menuVisibilityClass = 'menu--visible',
                submenuVisiblityClass = 'menu__submenu--visible',


                body = $('body'),
                menu = $('.navigation-bar').find('.menu__submenu'),

                desktopMenus = [];


            function Menu() {
                this.addMobileBreakPoint();
                this.addDesktopBreakPoint();
                this.bindClickCategoryItems();
            }

            Menu.prototype.addMobileBreakPoint = function() {
                var _this = this;

                respond.atBreakpoint(
                    settings.breakpoints.smallOnly.min,
                    settings.breakpoints.mlarge.min,
                    function () {
                        _this.mobile = new MobileMenu();
                    },
                    function () {
                        _this.mobile.destroy();
                    }
                );
            };

            Menu.prototype.addDesktopBreakPoint = function() {
                respond.atBreakpoint(
                    settings.breakpoints.mlarge.min,
                    settings.breakpoints.mlarge.max,
                    function () {
                        menu.find('.menu__submenu--multi-col').each(function () {
                            desktopMenus.push(new DesktopMenu($(this)));
                        });
                    },
                    function () {
                        for (var i = 0; i < desktopMenus.length; i++) {
                            desktopMenus[i].destroy();
                        }
                    }
                );
            };

            /**
             * Reload the page if a link in the menu was clicked.
             * Effect only links with none empty hash.
             * Doesn't have effect if page is redirected.
             *
             * @method bindClickCategoryItems
             */
            Menu.prototype.bindClickCategoryItems = function() {
                menu.on('click', 'a', function(e) {
                    var href = $(this).prop('href');
                    if (/#.+$/.test(href)) {
                        $(window).one('hashchange', function() {
                            window.location.reload();
                        });
                    }
                });
            };

            /**
             * @class MobileMenu
             * @description mobile Subclass
             */
            function MobileMenu() {
                this.destroyList = $.Deferred();

                this.bindOpenButton();
                this.bindOpenSubmenu();
                this.bindBackButton();
                this.bindCloseButton();
            }

            MobileMenu.prototype.bindOpenButton = function() {
                var callback = function(e) {
                        e.preventDefault();
                        $('.menu').addClass(menuVisibilityClass);
                        bodyScroll.lock();
                    };

                body.on('click', '.menu__open-button', callback);
                this.destroyList.done(function() {
                    body.off('click', '.menu__open-button', callback);
                });
            };

            MobileMenu.prototype.bindOpenSubmenu = function() {
                var callback = function(e) {
                        e.preventDefault();
                        $(this)
                            .closest('.menu__item--has-children')
                            .find('> .menu__submenu')
                            .addClass(submenuVisiblityClass);
                    };
                
                body.on('click', '.menu__item--has-children>.menu__item__wrapper>a, .menu__open-submenu-button', callback);
                this.destroyList.done(function() {
                    body.off('click', '.menu__item--has-children>.menu__item__wrapper>a, .menu__open-submenu-button', callback);
                });
            };

            MobileMenu.prototype.bindCloseButton = function() {
                var callback = function(e) {
                        e.preventDefault();
                        $(this).closest('.menu').removeClass(menuVisibilityClass);
                        bodyScroll.unlock();
                    };

                body.on('click', '.menu__close-button', callback);
                this.destroyList.done(function() {
                    body.off('click', '.menu__close-button', callback);
                });
            };

            MobileMenu.prototype.bindBackButton = function() {
                var callback = function(e) {
                        e.stopPropagation();
                        $(this).closest('.menu__submenu').removeClass(submenuVisiblityClass);
                    };

                body.on('click', '.menu__back-button', callback);
                this.destroyList.done(function() {
                    body.on('click', '.menu__back-button', callback);
                });
            };

            MobileMenu.prototype.destroy = function() {
                this.destroyList.resolve();
            };


            /**
             * @class DesktopMenu
             * @description desktop Subclass
             */
            function DesktopMenu($multiColMenu) {
                this.destroyList = $.Deferred();
                this.currentOpenedMenuItem = false;

                this.multiColumnMenu = $multiColMenu;
                this.multiColumnMenuItems = this.multiColumnMenu.find('li:not(.menu__back-button):not(.menu__feature-image) > a, .menu__item__wrapper > a');
                this.featuredImage = $multiColMenu.find('.menu__feature-image');

                this.bindClickMenuItem();
            }

            /**
             * Init columns' view on menu
             * Add binders on resize
             *
             * @method initColumns
             */
            DesktopMenu.prototype.initColumns = function() {
                var _this = this;

                if (this.destroyColumnsOnClosetimeout) {
                    window.clearTimeout(this.destroyColumnsOnClosetimeout);
                    this.destroyColumnsOnClosetimeout = false;
                }

                this.generateColumns();
                $(window).on('resize.responsiveMenuColumns', function() {
                    _this.generateColumns();
                });

                this.destroyList.done(function() {
                    _this.destroyColumns();
                });
            };

            /**
             * Set columns, height of multicolumn menu, width and position of links...
             *
             * @method generateColumns
             */
            DesktopMenu.prototype.generateColumns = function() {
                var featuredImageHeight = this.featuredImage.outerHeight(),
                    multiColumnMenuHeight = this.multiColumnMenu.outerHeight(),
                    _this = this;

                if ( !this.multiColumnMenu.length || this.multiColumnMenuItems.length < 1) {
                    return;
                }

                var firstTop = this.multiColumnMenuItems.first().parent().offset().top,
                    totalHeight = this.multiColumnMenuItems.last().parent().offset().top - firstTop + this.multiColumnMenuItems.last().parent().outerHeight(),
                    totalWidth = menu.width(),
                    itemWidth = this.multiColumnMenuItems.first().outerWidth(),
                    nColumns = Math.floor(totalWidth/itemWidth) - (this.featuredImage.length ? 1 : 0),
                    columnHeight = Math.ceil( nColumns > 1 ? totalHeight/nColumns : totalHeight),
                    iColumn = 0,
                    iFirstTop = firstTop,
                    maxColumnHeight = 0,
                    imaxColumnHeight = 0,
                    iOffsetTop,
                    menuItem;


                this.multiColumnMenuItems.each(function(i) {
                    menuItem = $(this);
                    iOffsetTop = menuItem.parent().offset().top;

                    // Init new column
                    if ( iOffsetTop - iFirstTop >= columnHeight ) {

                        if ( menuItem.find('li') ) {
                            imaxColumnHeight = 0;
                            iFirstTop = iOffsetTop;
                            iColumn++;
                        } else {
                            columnHeight += menuItem.outerHeight();
                        }
                    }

                    // Calculate the height of submenu
                    imaxColumnHeight = iOffsetTop - iFirstTop + menuItem.parent().outerHeight() ;
                    if (imaxColumnHeight > maxColumnHeight) {
                        maxColumnHeight = imaxColumnHeight;
                    }

                    // Position elements in menu
                    if ( iColumn ) {
                        menuItem.css({
                            'position': 'relative',
                            'left': (iColumn) * itemWidth + 'px',
                            'top': -1 * (iFirstTop - firstTop) + 'px'
                        });
                    } else {
                        // Clean up positioning for the first column
                        menuItem.css({
                            'position': '',
                            'left': '',
                            'top': ''
                        });
                    }
                });

                // Set the height of submenu
                this.multiColumnMenu.css('max-height', Math.max(maxColumnHeight, featuredImageHeight));
            };

            /**
             * Clean up the styles made by generateColumns after menu is closed.
             *
             * @method destroyColumnsOnClose
             */
            DesktopMenu.prototype.destroyColumnsOnClose = function() {
                var _this = this;

                this.destroyColumnsOnClosetimeout =  window.setTimeout(function() {
                    _this.multiColumnMenu.css('max-height', 0);
                }, settings.transitionTime);

                $(window).off('resize.responsiveMenuColumns');
            };

            /**
             * Clean up the styles made by generateColumns
             * Remove binding on window.resize
             *
             * @method destroyColumns
             */
            DesktopMenu.prototype.destroyColumns = function() {
                this.multiColumnMenu.css('max-height', '');
                this.multiColumnMenuItems.css({
                    'position': '',
                    'left': '',
                    'top': ''
                });

                $(window).off('resize.responsiveMenuColumns');
            };

            DesktopMenu.prototype.bindClickMenuItem = function() {
                var _this = this,
                    callback = function(e) {
                        $.each(desktopMenus, function (i) {
                            if (desktopMenus[i] !== _this) {
                                desktopMenus[i].closeMenu();
                            }
                        });

                        var link = $(this).find('> .menu__item__wrapper').find('a')[0];

                        if (e.target === link) {
                            e.preventDefault();

                            var menuItem = $(this);

                            if (_this.currentOpenedMenuItem) {
                                if (_this.isMenuOpened(menuItem)) {
                                    _this.closeMenu();

                                } else {
                                    _this.closeMenu();
                                    _this.openMenu(menuItem);
                                }

                            } else {
                                _this.openMenu(menuItem);
                            }
                        }
                    };

                var menuItem = this.multiColumnMenu.closest('.menu__item--has-children');

                menuItem.on('click', callback);

                //body.on('click', '.menu > .menu__item--has-children', callback);
                this.destroyList.done(function() {
                    //body.on('click', '.menu__item--has-children', callback);
                    menuItem.off('click', callback);
                });
            };

            DesktopMenu.prototype.isMenuOpened = function(menuItem) {
                return menuItem.hasClass('menu__item--active');
            };

            DesktopMenu.prototype.openMenu = function(menuItem) {
                this.initColumns();

                this.closeList = $.Deferred();
                this.currentOpenedMenuItem = menuItem;

                var submenu = menuItem.find('> .menu__submenu');

                menuItem.addClass('menu__item--active');
                submenu.addClass(submenuVisiblityClass);
                this.bindEscape();
                this.bindClickOutsideOpenedMenu();

                this.enableSubmenuFitScreen(submenu);
            };

            DesktopMenu.prototype.closeMenu = function() {
                if (this.currentOpenedMenuItem) {
                    this.destroyColumnsOnClose();

                    this.currentOpenedMenuItem.removeClass('menu__item--active');
                    this.currentOpenedMenuItem.find('> .menu__submenu').removeClass(submenuVisiblityClass);
                    this.currentOpenedMenuItem = false;
                    this.closeList.resolve();
                    this.disableSubmenuFitScreen();
                }
            };

            DesktopMenu.prototype.bindEscape = function() {
                var _this = this;

                bindStack.pushEscapeCallback(function (e) {
                    _this.closeMenu();
                });

                this.closeList.done(function() {
                    bindStack.popEscapeCallback();
                });
            };

            DesktopMenu.prototype.bindClickOutsideOpenedMenu = function() {
                var _this = this,
                    callback = function(e) {
                        var target = $(e.target);
                        if ( ! $(e.target).closest('.menu__item--active').length ) {
                            _this.closeMenu();
                        }
                    };

                body.on('click', callback);
                this.closeList.done(function() {
                    body.off('click', callback);
                });
            };

            /**
             * Makes possible to have submenu as big as possible. Enables scroll if needed, so submenu fits the screen.
             *
             * @method enableSubmenuFitScreen
             */
            DesktopMenu.prototype.enableSubmenuFitScreen = function(submenu) {
                var _this = this;
                this.disableSubmenuFitScreen();

                window.setTimeout(function() {
                    _this._fsv = new FitScreenVertically(submenu);
                    _this._fsv.enable();
                }, settings.transitionTime);

                _this.destroyList.done(function() {
                    _this.disableSubmenuFitScreen();
                });
            };

            /**
             * Turn off linstening of scroll and window resize to make submenu fit the screen.
             *
             * @method disableSubmenuFitScreen
             */
            DesktopMenu.prototype.disableSubmenuFitScreen = function() {
                if ( this._fsv ) {
                    this._fsv.disable();
                }
            };

            DesktopMenu.prototype.destroy = function() {
                this.closeMenu();
                this.destroyList.resolve();
            };

            return new Menu();
        };

        return Menu;
    }
);

